import { clsx } from "clsx";

export const getTabClassName = ({ active }: { active?: boolean }) => {
  const baseStyles =
    "flex items-center gap-2 px-2 pb-4 font-inter font-semibold cursor-pointer";
  const activeStyles = "border-b-2 border-blue-660 mb-[-1px]";

  return clsx(baseStyles, active && activeStyles);
};

export const getTabLabelClassName = ({ active }: { active?: boolean }) => {
  const baseStyles = "py-4 px-1 text-neutral-600";
  const activeStyles = "text-neutral-850";

  return clsx(baseStyles, active && activeStyles);
};
